export const formatPrice = (inputValue, country = 'br') => {
  // Remove todos os caracteres não numéricos do valor de entrada
  const numericValue = inputValue.replace(/\D/g, '')

  const locale = country === 'br' ? 'pt-BR' : 'en-US'
  const currency = country === 'br' ? 'BRL' : 'USD'
  // Formata o valor como moeda (R$ X,XX)
  const formattedPrice = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  }).format(numericValue / 100)
  return formattedPrice
}
